import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, Lock, X } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface UpsellPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function UpsellPopup({
  isOpen,
  onClose
}: UpsellPopupProps) {
  const fullBundleUrl = 'https://tumentesoberana.com/cart/48585331540187:1';
  const mainProductUrl = 'https://tumentesoberana.com/cart/48520192164059:1';
  const handleAccept = () => {
    trackInitiateCheckout();
    window.location.href = fullBundleUrl;
  };
  const handleDecline = () => {
    trackInitiateCheckout();
    window.location.href = mainProductUrl;
  };
  return <AnimatePresence data-id="element-424">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-425">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-426" />

          {/* Popup Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-2xl bg-[#0a0e27] border-2 border-yellow-500/30 rounded-2xl shadow-[0_0_50px_rgba(212,175,55,0.15)] overflow-hidden flex flex-col max-h-[90vh]" data-id="element-427">
            {/* Close button */}
            <button onClick={onClose} className="absolute top-4 right-4 z-10 text-gray-400 hover:text-white bg-black/20 hover:bg-black/40 rounded-full p-2 transition-colors" data-id="element-428">
              <X className="w-5 h-5" data-id="element-429" />
            </button>

            {/* Header Banner */}
            <div className="bg-gradient-to-r from-red-600 to-red-700 text-center py-2 px-4 relative overflow-hidden" data-id="element-430">
              <div className="animate-[flash_2s_infinite] text-white font-bold text-sm tracking-wider" data-id="element-431">
                ⚡ OFERTA ÚNICA — SOLO EN ESTA PANTALLA ⚡
              </div>
            </div>

            <div className="p-6 sm:p-8 overflow-y-auto" data-id="element-432">
              <div className="text-center mb-6" data-id="element-433">
                <h2 className="text-2xl sm:text-3xl font-black text-white mb-2" data-id="element-434">
                  🛑 ¡ESPERA! No te vayas sin esto...
                </h2>
                <p className="text-lg text-gray-300" data-id="element-435">
                  Descubrimos algo que puede cambiar todo para ti
                </p>
              </div>

              {/* Body */}
              <div className="bg-[#1a1f3a] border border-white/10 rounded-xl p-5 mb-6 text-center relative" data-id="element-436">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-500 text-slate-900 font-black px-4 py-1 rounded-full text-sm animate-[flash_2s_infinite]" data-id="element-437">
                  -30% EN EL PAQUETE COMPLETO
                </div>
                <p className="text-gray-200 mt-3 mb-2 leading-relaxed" data-id="element-438">
                  Estás a un paso de liberar tu energía, pero sin las
                  herramientas completas, podrías quedarte a medio camino. Este
                  paquete te da TODO lo que necesitas para una transformación
                  total.
                </p>
                <p className="text-yellow-400 font-semibold" data-id="element-439">
                  Llévate el paquete completo con un descuento exclusivo que NO
                  volverá a aparecer.
                </p>
              </div>

              {/* What's Included */}
              <div className="mb-8" data-id="element-440">
                <h3 className="text-white font-bold mb-3 text-lg" data-id="element-441">
                  Lo que te llevas hoy:
                </h3>
                <ul className="space-y-3" data-id="element-442">
                  <li className="flex items-start" data-id="element-443">
                    <Check className="w-5 h-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-444" />
                    <span className="text-gray-300" data-id="element-445">
                      <strong className="text-white" data-id="element-446">
                        Guía Maestra de Liberación y Protección Energética
                      </strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-447">
                    <Check className="w-5 h-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-448" />
                    <span className="text-gray-300" data-id="element-449">
                      Bono 1: Guía Sagrada de Baños y Despojos
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-450">
                    <Check className="w-5 h-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-451" />
                    <span className="text-gray-300" data-id="element-452">
                      Bono 2: Manifiesta tu Realidad en 7 Días
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-453">
                    <Check className="w-5 h-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-454" />
                    <span className="text-gray-300" data-id="element-455">
                      Bono 3: Protocolo de Emergencia: Escudo 60s
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-456">
                    <Check className="w-5 h-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-457" />
                    <span className="text-gray-300" data-id="element-458">
                      <strong className="text-yellow-400" data-id="element-459">
                        Reprograma tu Mente y Activa tu Riqueza
                      </strong>{' '}
                      — Atrae riqueza real y sostenida
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-460">
                    <Check className="w-5 h-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-461" />
                    <span className="text-gray-300" data-id="element-462">
                      <strong className="text-yellow-400" data-id="element-463">
                        Deja de Sanar y Comienza a Cerrar
                      </strong>{' '}
                      — Cierra ciclos y libérate del pasado
                    </span>
                  </li>
                </ul>
              </div>

              {/* Pricing Block */}
              <div className="bg-black/40 rounded-xl p-6 text-center border border-white/5 mb-6" data-id="element-464">
                <div className="text-gray-500 line-through decoration-red-500 decoration-2 text-xl mb-1" data-id="element-465">
                  $23 USD
                </div>
                <div className="text-5xl font-black text-white mb-2" data-id="element-466">
                  $16 <span className="text-2xl text-yellow-400" data-id="element-467">USD</span>
                </div>
                <div className="text-sm text-yellow-400 font-medium mb-3" data-id="element-468">
                  Precio especial solo disponible en esta pantalla
                </div>
                <div className="flex items-center justify-center text-gray-400 text-xs" data-id="element-469">
                  <Lock className="w-3 h-3 mr-1.5" data-id="element-470" />
                  Pago seguro y acceso instantáneo
                </div>
              </div>

              {/* CTAs */}
              <div className="flex flex-col items-center space-y-4" data-id="element-471">
                <button onClick={handleAccept} className="w-full bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 text-slate-900 font-black text-lg sm:text-xl py-4 px-6 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] hover:-translate-y-1 transition-all duration-300 animate-[pulse_2s_ease-in-out_infinite] flex flex-col items-center" data-id="element-472">
                  <span data-id="element-473">¡SÍ! QUIERO EL PAQUETE COMPLETO POR $16 USD</span>
                  <span className="text-xs font-normal opacity-80 mt-1" data-id="element-474">
                    + impuestos según tu país
                  </span>
                </button>

                <button onClick={handleDecline} className="text-gray-500 hover:text-gray-300 text-sm underline underline-offset-4 transition-colors" data-id="element-475">
                  No gracias, continuar sin los extras →
                </button>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}